/**
 * Prostokąt widoczności - określa granice obszaru do narysowania
 */
export class RequiredVisibilityRect {
    constructor(
        readonly x1: number,
        readonly y1: number,
        readonly x2: number,
        readonly y2: number
    ) {
    }

    static merge(...rects: RequiredVisibilityRect[]): RequiredVisibilityRect {
        if (rects.length === 0) {
            return new RequiredVisibilityRect(0, 0, 0, 0);
        }
        const minX = Math.min(...rects.map(r => r.x1));
        const minY = Math.min(...rects.map(r => r.y1));
        const maxX = Math.max(...rects.map(r => r.x2));
        const maxY = Math.max(...rects.map(r => r.y2));
        return new RequiredVisibilityRect(minX, minY, maxX, maxY);
    }

    get width(): number {
        return Math.abs(this.x2 - this.x1);
    }

    get height(): number {
        return Math.abs(this.y2 - this.y1);
    }
}